import { SelleRankingHeader } from 'v3/pages/SellersRanking/Header';
import { SellerRankTable } from 'v3/shared/components/Table/RankSellerTable';
import { CommonTemplate } from 'v3/shared/templates/CommonTemplate';
import { Content } from '../ListRank/styles';

export const SellerRankingList = () => {
  return (
    <CommonTemplate>
      <SelleRankingHeader />
      <Content>
        <SellerRankTable />
      </Content>
    </CommonTemplate>
  );
};
